import { TranslateService } from '@ngx-translate/core';
import { RBCheck } from '@ldw/roesberg';

export class MenuCommand {
  public icon = '';
  public route = '';
  public transId = '';
  public customText = '';
  public needWebDoku = false;
  public isExternalRoute = false;

  constructor(protected translate: TranslateService) {}

  get text(): string {
    if (!RBCheck.isNullOrEmpty(this.customText)) {
      return this.customText;
    }
    return this.translate.instant('COMMANDS.' + this.transId.toUpperCase());
  }
}
